import { currencyCode } from '../../utils/currency';
import { RESPONSIBLE_PERIODS } from '../../utils/responsibleLimits';

function formatDepositCurrentAmount(value) {
  const num = Number(value);
  if (!Number.isFinite(num)) return '';
  const grouped = String(Math.round(num)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return `${grouped} ${currencyCode()}`;
}

export default function MobileResponsibleDepositCurrent({ limits, t }) {
  const current = limits?.current || {};
  const items = RESPONSIBLE_PERIODS.flatMap((period) => {
    const item = current[period];
    if (!item?.enabled || item.value == null) return [];
    return [{
      key: period,
      label: t(`account.responsible.${period}Limit`),
      amount: formatDepositCurrentAmount(item.value),
    }];
  });

  if (!items.length) return null;

  return (
    <div className="mobile-responsible-deposit-current">
      <div className="mobile-responsible-deposit-current__caption">{t('account.responsible.currentLimits')}</div>
      <div className="mobile-responsible-deposit-current__container">
        <div className="mobile-responsible-deposit-current__list">
          {items.map((item) => (
            <div key={item.key} className="mobile-responsible-deposit-current__item">
              <div className="mobile-responsible-deposit-current__caption-row">
                <div className="mobile-responsible-deposit-current__label">{item.label}</div>
                <div className="mobile-responsible-deposit-current__amount">{item.amount}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
